"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageError = exports.NotFoundError = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _common = require("@webex/common");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * General storage layer error
 */
var StorageError = /*#__PURE__*/function (_Exception) {
  (0, _inherits2.default)(StorageError, _Exception);
  var _super = _createSuper(StorageError);
  function StorageError() {
    (0, _classCallCheck2.default)(this, StorageError);
    return _super.apply(this, arguments);
  }
  return (0, _createClass2.default)(StorageError);
}(_common.Exception);
/**
 * StorageError thrown when the storage layer does not contain the request key
 */
exports.StorageError = StorageError;
var NotFoundError = /*#__PURE__*/function (_StorageError) {
  (0, _inherits2.default)(NotFoundError, _StorageError);
  var _super2 = _createSuper(NotFoundError);
  function NotFoundError() {
    (0, _classCallCheck2.default)(this, NotFoundError);
    return _super2.apply(this, arguments);
  }
  return (0, _createClass2.default)(NotFoundError);
}(StorageError);
exports.NotFoundError = NotFoundError;
//# sourceMappingURL=errors.js.map
